import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import DefaultLayout from "../../components/layout/DefaultLayout"
import AdminRegistration from "../../components/registrationTable/AdminRegistration"

const Registration = () => {
  const { user } = useSelector((state) => state.user)

  useEffect(() => {}, [])

  return (
    <DefaultLayout>
      {user?.role !== "admin" ? (
        <h1>You are not authorized to view this page, Contact manager.</h1>
      ) : (
        <AdminRegistration />
      )}
    </DefaultLayout>
  )
}

export default Registration
